const Theme = {
  colors: {
    grey: '#F4F4F4',
    greySelected: '#8a8a8a',
  },
};
export default Theme;
